/**
 * Placeholder for hidden block.
 */

import type { RenderElementPropsExt } from '@tunasong/plugin-lib'
import type { HTMLAttributes } from 'react'
import styles from './hidden-block.module.css'

type HiddenBlockProps = Omit<RenderElementPropsExt, 'element'> &
  Omit<HTMLAttributes<HTMLDivElement>, 'children'> & {
    text?: string
  }

export const HiddenBlock = ({ text = 'Hidden', children, ...restProps }: HiddenBlockProps) => (
  <div className={styles.hidden} {...restProps}>
    {text}
    <div className={styles.hiddenChildren}>{children}</div>
  </div>
)
